import { render, staticRenderFns } from "./add-dietitian.vue?vue&type=template&id=4b02b8dc&scoped=true&"
import script from "./add-dietitian.vue?vue&type=script&lang=js&"
export * from "./add-dietitian.vue?vue&type=script&lang=js&"
import style0 from "./add-dietitian.vue?vue&type=style&index=0&id=4b02b8dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b02b8dc",
  null
  
)

export default component.exports